import { ContentTypes } from "../brandVariables.types";

export const legoContent: ContentTypes = {
  generalHeadline: "Er du hurtigere end Johnni Gade?",
  generalHeadlineAlt: "Slå Johnni’s tid og du er med i lodtrækningen om et",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "Lego X F1 winners",
  endscreenHeadline: "Thank you and congratulations to our winners",
};
